import { useCallback, useEffect, useRef, useState } from 'react';

// Les garde-fous de l'envoi vus de la page, en un seul import (la page ne doit pas grossir).
export { depasseLaBorne } from './borneEquipements';

/**
 * Le refus du serveur sur un numéro d'appareil, et le moment où il cesse d'être vrai (lot L4).
 *
 * Le serveur refuse un chantier (409) dont un numéro appartient déjà à un autre dossier,
 * et nomme l'équipement. Le poseur corrige à l'étape des équipements : dès qu'un NUMÉRO
 * change, le refus ne dit plus rien de vrai et disparaît. Changer une marque ne règle
 * rien : il reste.
 *
 * ⚠️ TOUS LES NUMÉROS, PAS DEUX CLÉS. La première version ne regardait que
 * `identifiant_equipement` et `thermostat_serial` : un radiateur se corrige par
 * `unites[]`, un PV par `onduleur_id`, et le refus restait affiché après la correction
 * (relecture ux du 27/10). On compare donc l'ensemble des numéros avant et après.
 */
const CHAMPS_DE_NUMERO = ['identifiant_equipement', 'thermostat_serial', 'onduleur_id', 'onduleur_serial'];

const numerosDe = (bloc) => CHAMPS_DE_NUMERO.map((champ) => (bloc && bloc[champ]) || '');

/** Empreinte des numéros saisis, tous équipements et toutes unités : change si l'un change. */
export function numerosSaisis(equipements) {
  return Object.keys(equipements || {}).sort().map((type) => {
    const bloc = equipements[type] || {};
    const unites = (bloc.unites || []).map((u) => numerosDe(u).join('|'));
    // `enabled` en fait partie : décocher l'équipement refusé règle aussi le refus.
    return `${type}:${bloc.enabled ? 1 : 0}:${numerosDe(bloc).join('|')}:${unites.join(',')}`;
  }).join(';');
}

/**
 * `{ refus, retenir }`. `retenir(erreur)` garde le détail d'un 409 (et rien d'autre : une
 * photo illisible ou une panne réseau n'est pas un refus d'équipement). Le refus, et
 * l'erreur affichée qui le porte, s'effacent quand un numéro change.
 */
export function useRefusDuServeur(equipements, setError) {
  const [refus, setRefus] = useState('');
  const numeros = numerosSaisis(equipements);
  const precedents = useRef(numeros);
  const refusCourant = useRef('');
  useEffect(() => {
    if (precedents.current === numeros) return;
    precedents.current = numeros;
    if (refusCourant.current) {
      refusCourant.current = '';
      setRefus('');
      setError('');
    }
  }, [numeros, setError]);
  const retenir = useCallback((erreur) => {
    const detail = erreur?.response?.status === 409 ? erreur.response.data?.detail : '';
    refusCourant.current = typeof detail === 'string' ? detail : '';
    setRefus(refusCourant.current);
  }, []);
  return { refus, retenir };
}
